/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICoreContext } from '@msdyn365-commerce/core';
import { Module } from '@msdyn365-commerce-modules/utilities';

import { IDlvryTileContainerData } from './dlvry-tile-container.data';
import { IDlvryTileContainerProps as IDlvryTileContainerPropsAuto } from './dlvry-tile-container.props.autogenerated';
import { IAppSettingsInContext } from '../../settings/app.settings.autogenerated';

export interface IDlvryTileContainerViewProps extends IDlvryTileContainerPropsAuto<IDlvryTileContainerData> {}

export interface IDlvryTileContainerProps extends IDlvryTileContainerPropsAuto<IDlvryTileContainerData> {
    context: ICoreContext<IAppSettingsInContext>;
}

/**
 *
 * DlvryTileContainer component
 * @extends {React.PureComponent<IDlvryTileContainerProps>}
 */
class DlvryTileContainer extends React.PureComponent<IDlvryTileContainerProps> {

    private baseClassName = 'dlvry-tile-container';

    public render(): JSX.Element | null {
        const { slots } = this.props;

        return (
            <Module className={this.baseClassName} moduleProps={this.props}>
                {slots.content}
            </Module>
        );
    }
}

export default DlvryTileContainer;
